export default __webpack_public_path__ + "static/media/image-ph-study-main-1-n-w@3x.89ee06d2.webp";